import { useCallback, useEffect } from "react";
import { debounce } from "lodash";

import { useViewActions } from "../../store";

export function useWindowResizeHook(): void {
  const { setWindowSizeAction } = useViewActions();

  const setWindowSize = useCallback(() => {
    setWindowSizeAction({
      height: window.innerHeight,
      width: window.innerWidth,
    });
  }, []);

  const setWindowSizeDebounced = debounce(setWindowSize, 1000);

  useEffect(() => {
    window.addEventListener("resize", setWindowSizeDebounced);

    return () => {
      window.removeEventListener("resize", setWindowSizeDebounced);
    };
  }, []);
}
